import { ContainedIcon } from '@frontend/icons';

export const ScheduledAdded = ({ as = 'span' }: { as?: React.ElementType }) => {
  return (
    <ContainedIcon
      as={as}
      css={{
        padding: 1,
        borderRadius: 'var(--fabric-radius-sm)',
      }}
      iconName='calendar-add'
      color={'var(--fabric-color-blue-50)'}
    />
  );
};
